import { FaCrown, FaUserPlus } from "react-icons/fa";

const TopStylists = ({ topStylists, topReferrers }) => {
    const topThree = topStylists?.slice(0, 3);
    const topFive = topReferrers?.slice(0, 5);
    console.log("topReferrers",topReferrers);

    const crownColors = ["text-yellow-500", "text-gray-400", "text-amber-700"];

    return (
        <div className="flex gap-5">
            <div className=" space-y-3 p-3 bg-white rounded-lg shadow-sm dark:bg-gray-900 dark:border-gray-800 dark:bg-white/[0.03]">
                <div className="flex items-center gap-5">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                    Top Stylists
                </h3>
                    <FaCrown className={`w-5 h-5 text-[#CA8A04]`} /> 
                </div>
                
                {topThree?.map((stylist, index) => (
                    <div
                        key={stylist.stylistId}
                        className="flex items-center justify-between p-1  dark:bg-gray-900 gap-4"
                    >
                        <div className="flex items-center gap-2">
                            <FaCrown className={`w-5 h-5 ${crownColors[index]}`} />
                            <span className="font-medium text-gray-800 dark:text-white">
                                {stylist?.stylistName || "-"} :
                            </span>
                        </div>
                        <span className="text-sm text-gray-600 dark:text-gray-300">
                             {stylist?.matches || "-"}
                        </span>
                    </div>
                ))}
            </div>
            <div className=" space-y-3 p-3 bg-white rounded-lg shadow-sm dark:bg-gray-900 dark:border-gray-800 dark:bg-white/[0.03]">
                <div className="flex items-center gap-4">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                        Top Referrals
                    </h3>
                    <FaUserPlus className={`w-5 h-5 text-[#CA8A04]`} /> 
                </div>

                {topFive?.map((referrers, index) => (
                    <div
                        key={referrers.stylistId}
                        className="flex items-center justify-between p-1  dark:bg-gray-900 gap-6"
                    >
                        <div className="flex items-center gap-4">
                            <FaUserPlus className={`w-5 h-5 text-amber-600`} />
                            <span className="font-medium text-gray-800 dark:text-white">
                                {referrers?.fullName || "-"}
                            </span>
                        </div>
                        <span className="text-sm text-gray-600 dark:text-gray-300 items-start">
                            {referrers?.email || "-"}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopStylists;
